
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Airportpickupanddropinpune() {



    const cardData =
    {
        keyword: 'Airport Pickup and Drop in Pune',
        heading: 'Platinum24 Cabs: Airport Pickup and Drop in Pune',
        headingDescription: ' Platinum24 Cabs offers reliable Airport Pickup and Drop in Pune, ensuring safe, timely, and comfortable transfers to and from Pune International Airport. Our fleet of hatchbacks, sedans, SUVs, and luxury cars is available 24/7, making travel easy for solo passengers, families, and corporate clients. With professional chauffeurs, real-time tracking, and transparent fares, we guarantee stress-free airport transfers every time. Whether it’s an early morning drop, late-night pickup, or regular business travel, Platinum24 Cabs provides punctual, affordable, and dependable airport cab services across Pune.',

        top: 'Top Places to Visit in Pune with Platinum24 Cabs',

"topPlaces": [
  {
    "title": "Kaas Plateau (Valley of Flowers)",
    "description": "Kaas Plateau, a UNESCO World Natural Heritage Site near Satara, is famous for its seasonal bloom of wildflowers. From August to October, the plateau turns into a colorful carpet of orchids, lilies, and rare species. Nature lovers and photographers flock here for its breathtaking landscapes. The site is carefully protected, ensuring eco-friendly tourism. Misty monsoons make it even more enchanting. Kaas Plateau is Satara’s crown jewel of natural beauty."
  },
  {
    "title": "Ajinkyatara Fort",
    "description": "Ajinkyatara Fort, perched at 3,300 feet, offers panoramic views of Satara city. Built in the 16th century, it played a strategic role in Maratha history. The fort has bastions, gates, and temples like Hanuman and Devi shrines. Trekking up is moderately easy and rewarding with scenic vistas. It is especially popular during monsoon. Ajinkyatara Fort is Satara’s living reminder of Maratha valor."
  },
  {
    "title": "Thoseghar Waterfall",
    "description": "Thoseghar Waterfall near Satara is a breathtaking cascade that plunges from over 1,000 feet. Surrounded by lush green hills, it is one of Maharashtra’s tallest waterfalls. Monsoon transforms it into a thundering natural wonder. Visitors enjoy viewpoints and picnic spots nearby. Photographers capture its majestic flow and misty ambiance. Thoseghar is Satara’s monsoon paradise."
  },
  {
    "title": "Sajjangad Fort",
    "description": "Sajjangad Fort is a revered spiritual site, known as the final resting place of Sant Ramdas, spiritual guide of Chhatrapati Shivaji Maharaj. Pilgrims visit for its temples and ashrams, where bhajans and prayers create a divine aura. The fort also offers scenic views of valleys and lakes. Devotees believe visiting here grants peace and blessings. Sajjangad is Satara’s sacred blend of history and spirituality."
  },
  {
    "title": "Koyna Dam & Wildlife Sanctuary",
    "description": "Koyna Dam, built on the Koyna River, is one of India’s largest hydroelectric projects. Surrounded by the Western Ghats, it creates the beautiful Shivsagar Lake. The nearby Koyna Wildlife Sanctuary is home to tigers, leopards, and diverse flora and fauna. Monsoon enhances the greenery and water levels, making it a scenic retreat. Boating and nature walks are popular here. Koyna is Satara’s powerhouse of beauty and energy."
  },
  {
    "title": "Natraj Mandir, Satara",
    "description": "Natraj Mandir in Satara is a unique temple dedicated to Lord Shiva in the form of Nataraja, inspired by the famous Chidambaram temple of Tamil Nadu. Its Dravidian-style architecture and intricate carvings attract devotees and tourists. The temple is serene and spiritually uplifting. Festivals like Mahashivratri draw large crowds. Surrounded by peaceful ambiance, it is ideal for meditation. Natraj Mandir is Satara’s sacred cultural landmark."
  },
  {
    "title": "Kaas Lake",
    "description": "Kaas Lake, located near the famous Kaas Plateau, is a tranquil water body surrounded by greenery. It was originally built as a reservoir for Satara. The calm environment makes it ideal for relaxation and photography. Migratory birds can be spotted during certain seasons. Tourists often combine a visit with the flower valley. Kaas Lake is Satara’s peaceful natural retreat."
  },
  {
    "title": "Chalkewadi Windmill Farms",
    "description": "Chalkewadi Windmill Farms, near Thoseghar, feature hundreds of giant windmills dotting the hills. It is one of Maharashtra’s largest wind energy projects. The landscape looks surreal, especially during monsoon with mist and waterfalls around. Tourists enjoy scenic drives and photography here. The site is peaceful yet futuristic in appeal. Chalkewadi is Satara’s blend of green energy and natural charm."
  },
  {
    "title": "Jarandeshwar Temple & Caves",
    "description": "Jarandeshwar Temple near Satara is dedicated to Lord Shiva and is located near ancient Buddhist caves. The caves have rock-cut architecture and historical significance. Pilgrims visit the temple for its divine aura and natural setting. The site is surrounded by forests and hills, making it serene. It attracts both history lovers and devotees. Jarandeshwar is Satara’s hidden gem of spirituality and heritage."
  },
  {
    "title": "Yamai Devi Temple, Aundh",
    "description": "Located near Satara, the Yamai Devi Temple at Aundh is an ancient and highly revered shrine. Dedicated to Goddess Yamai, it is an important pilgrimage site in Maharashtra. Devotees climb steps to reach the temple perched on a hilltop. The temple is especially vibrant during Navratri. It also offers panoramic views of the surrounding landscape. Yamai Devi Temple is Satara’s divine abode of faith and devotion."
  }
],



   "services": [
    {
      "name": "Pune Airport Pickup",
      "description": "Experience seamless Pune Airport Pickup service designed to make your arrival stress-free and comfortable. Our professional drivers monitor your flight timings and ensure punctual pickups right from the airport terminal. Enjoy a warm welcome and hassle-free baggage handling as you step out, with clean and well-maintained vehicles ready to take you safely to your destination anywhere in Pune or nearby areas."
    },
    {
      "name": "Pune Airport Drop Service",
      "description": "Our Pune Airport Drop Service guarantees timely and reliable transport to Pune Airport, ensuring you reach your flight well ahead of time. Whether it’s an early morning departure or a late-night flight, our drivers are punctual and familiar with airport routes and security procedures, providing you with a smooth, comfortable, and stress-free ride directly to the terminal."
    },
    {
      "name": "Airport Transfer Pune",
      "description": "Make your travel easier with our Airport Transfer Pune service, offering efficient point-to-point transfers between Pune Airport and any location in the city or surrounding regions. We cater to all kinds of travelers including business professionals, families, and tourists, providing a wide range of vehicle options to match your preferences and budget."
    },
    {
      "name": "Pune Airport Taxi Service",
      "description": "Choose our Pune Airport Taxi Service for dependable, round-the-clock airport transport. Our fleet consists of modern cars with professional chauffeurs trained to deliver safe and comfortable rides. We offer flexible booking options and real-time flight tracking to ensure timely pickups and drop-offs, making your airport travel experience smooth and hassle-free."
    },
    {
      "name": "Airport Pickup and Drop Cab Pune",
      "description": "Our Airport Pickup and Drop Cab Pune service covers both arrival and departure transfers, providing a comprehensive travel solution. With easy online booking and transparent pricing, you can rely on us for convenient, comfortable, and punctual rides. Whether traveling solo or with family, our vehicles accommodate all group sizes with spacious interiors and luggage space."
    },
    {
      "name": "Pune Airport Shuttle",
      "description": "Opt for our Pune Airport Shuttle for an economical and efficient shared ride service to and from the airport. Ideal for solo travelers or small groups looking to save on costs without compromising comfort, our shuttle service operates on fixed schedules and routes, ensuring reliable and timely airport connectivity."
    },
    {
      "name": "Airport Taxi Booking Pune",
      "description": "Book your airport taxi in Pune effortlessly through our user-friendly platform offering instant confirmation and competitive rates. Our Airport Taxi Booking Pune service provides a variety of vehicle options, from economy to luxury cars, with flexible payment options and 24/7 customer support for a hassle-free booking experience."
    },
    {
      "name": "Airport Cab Service Pune",
      "description": "Our Airport Cab Service Pune is designed to cater to all your airport transportation needs with professionalism and efficiency. From quick airport transfers to long-distance airport rides, our fleet and drivers are equipped to handle any request, ensuring you travel comfortably and arrive on time every time."
    },
    {
      "name": "Pune Airport Taxi with Driver",
      "description": "Travel comfortably with Pune Airport Taxi with Driver service, featuring courteous and experienced chauffeurs who assist you throughout your journey. Whether you need assistance with luggage or local recommendations, our drivers provide personalized service, ensuring a pleasant and stress-free airport transfer experience."
    },
    {
      "name": "Affordable Airport Pickup Pune",
      "description": "Avail Affordable Airport Pickup Pune services without compromising on quality or comfort. Our competitively priced rides ensure you get value for money while enjoying punctual pickups, clean vehicles, and professional drivers. Perfect for budget-conscious travelers seeking reliable airport transportation."
    },
    {
      "name": "Pune Airport Transfer Rates",
      "description": "We offer transparent and competitive Pune Airport Transfer Rates with no hidden charges, ensuring you know exactly what you pay upfront. Our pricing is based on vehicle type, distance, and service duration, providing flexible options for all budgets and travel needs."
    },
    {
      "name": "Pune Airport Taxi Deals",
      "description": "Take advantage of exclusive Pune Airport Taxi Deals offering discounts and special packages for frequent travelers, corporate clients, and group bookings. Enjoy premium airport taxi services at affordable prices with additional perks such as complimentary waiting time and free luggage assistance."
    },
    {
      "name": "Pune Airport Pick-up Booking",
      "description": "Make your Pune Airport Pick-up Booking easy and quick with our dedicated online platform and customer support. Schedule your pickup in advance and track your driver in real-time to avoid any delays or confusion, ensuring a smooth start to your journey in Pune."
    },
    {
      "name": "Pune Airport Taxi Service 24x7",
      "description": "Our Pune Airport Taxi Service 24x7 operates around the clock, ensuring you have reliable airport transport any time of the day or night. Whether you’re arriving on a red-eye flight or need an early morning airport drop, our taxis are always ready with professional drivers and well-maintained vehicles."
    },
    {
      "name": "Pune Airport Cab Service Near Me",
      "description": "Find the best Pune Airport Cab Service Near Me quickly and conveniently through our app or website. With a wide network of vehicles stationed throughout Pune, we ensure fast dispatch and minimal wait times wherever you are in the city, providing prompt and dependable airport taxi service."
    }
  ],
  "tableData": [
    ["Pune Airport Pickup", "Pune Airport Drop Service"],
    ["Airport Transfer Pune", "Pune Airport Taxi Service"],
    ["Airport Pickup and Drop Cab Pune", "Pune Airport Shuttle"],
    ["Airport Taxi Booking Pune", "Airport Cab Service Pune"],
    ["Pune Airport Taxi with Driver", "Affordable Airport Pickup Pune"],
    ["Pune Airport Transfer Rates", "Pune Airport Taxi Deals"],
    ["Pune Airport Pick-up Booking", "Pune Airport Taxi Service 24x7"],
    ["Pune Airport Cab Service Near Me", "—"]
  ],


        "whychoose": [
    {
      "WhyChooseheading": "Reliable Pune to Satara Cab Service",
      "WhyChoosedescription": "Platinum24 Cabs offers comfortable and timely cab rides from Pune to Satara for all your travel needs."
    },
    {
      "WhyChooseheading": "Experienced Drivers Familiar with Pune-Satara Routes",
      "WhyChoosedescription": "Our skilled drivers know the best routes to ensure a smooth and safe journey to Satara."
    },
    {
      "WhyChooseheading": "Clean and Spacious Vehicles for Comfortable Travel",
      "WhyChoosedescription": "Travel in well-maintained, air-conditioned cabs with ample space for passengers and luggage."
    },
    {
      "WhyChooseheading": "Flexible Booking for One-Way and Round Trips",
      "WhyChoosedescription": "Choose packages tailored to your travel plans from Pune to Satara and back."
    },
    {
      "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
      "WhyChoosedescription": "Enjoy upfront pricing that includes fuel, tolls, and driver allowances for a hassle-free experience."
    },
    {
      "WhyChooseheading": "24/7 Customer Support for Easy Booking",
      "WhyChoosedescription": "Our support team is available around the clock to assist with your cab bookings and queries."
    },
    {
      "WhyChooseheading": "Ideal for Family Trips, Corporate Travel, and Group Outings",
      "WhyChoosedescription": "Our Pune to Satara cab services cater to all types of travelers and occasions."
    },
    {
      "WhyChooseheading": "Multiple Vehicle Options to Suit Your Needs",
      "WhyChoosedescription": "Choose from hatchbacks, sedans, SUVs, or tempo travellers based on your group size and preferences."
    }
  ]





































    }

const faqData = [
    {
        question: 'Does Platinum24 Cabs offer airport pickup and drop services in Pune?',
        answer: 'Yes, Platinum24 Cabs provides reliable and timely airport pickup and drop services in Pune.',
    },
    {
        question: 'How can I book an airport pickup or drop service in Pune?',
        answer: 'You can book airport pickup or drop services through our website, mobile app, or by contacting our customer support team.',
    },
    {
        question: 'Are the drivers experienced in handling airport transfers in Pune?',
        answer: 'Yes, our drivers are professional, punctual, and well-versed with Pune airport protocols and routes.',
    },
    {
        question: 'What types of vehicles are available for airport transfers in Pune?',
        answer: 'We offer a range of vehicles including sedans, SUVs, and luxury cars to suit your comfort and group size.',
    },
    {
        question: 'Can I book airport transfer services at any time of the day?',
        answer: 'Yes, our airport pickup and drop services are available 24x7 to accommodate all flight timings.',
    },
    {
        question: 'Is there any waiting time included in the airport pickup service?',
        answer: 'Yes, we offer a reasonable waiting time for pickups to accommodate flight delays. Additional waiting charges may apply beyond that.',
    },
    {
        question: 'Are the vehicles sanitized and safe for airport transfers?',
        answer: 'Absolutely, all our vehicles are regularly sanitized and drivers follow strict safety protocols.',
    },
    {
        question: 'Can I book a one-way or round-trip airport transfer in Pune?',
        answer: 'Yes, we offer both one-way and round-trip airport transfer services as per your convenience.',
    },
    {
        question: 'Are airport transfers charged differently than regular cab rides?',
        answer: 'Airport transfer fares include vehicle charges, driver allowance, tolls, and applicable taxes. Pricing is competitive and transparent.',
    },
    {
        question: 'Does Platinum24 Cabs provide corporate airport transfer services in Pune?',
        answer: 'Yes, we provide customized corporate airport transfer solutions with priority service and flexible billing.',
    },
];

const testimonials = [
    {
        id: 1,
        name: 'Mr. Rohit Sharma',
        feedback: 'The airport pickup service in Pune was prompt and hassle-free. The driver was courteous and the car was clean.',
        rating: 5,
    },
    {
        id: 2,
        name: 'Ms. Anjali Desai',
        feedback: 'Booked an airport drop with Platinum24 Cabs. Service was smooth, and the driver reached well before time.',
        rating: 5,
    },
];




















































    const Images = [
        { place: "/images/keyword/1.jpg", text: "Pune Cab Service", link: "pune-cab-service" },
        { place: "/images/keyword/2.jpg", text: "Pune Taxi Hire", link: "pune-taxi-hire" },
        { place: "/images/keyword/3.jpg", text: "Pune Online Cab Booking", link: "pune-online-cab-booking" },
        { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "best-cab-service-in-pune" },
        { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Cabs", link: "pune-to-mumbai-cabs" },
        { place: "/images/keyword/6.jpg", text: "Pune to Nashik Cabs", link: "pune-to-nashik-cabs" },
        { place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cabs", link: "pune-to-mahabaleshwar-cabs" },
        { place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cabs", link: "pune-to-lonavala-cabs" },
        { place: "/images/keyword/9.jpg", text: "Pune to Shirdi Cab", link: "pune-to-shirdi-cab" },
        { place: "/images/keyword/10.jpg", text: "Pune to Bhimashankar Cab", link: "pune-to-bhimashankar-cab" },
        { place: "/images/keyword/11.jpg", text: "Pune to Konkan Darshan Cabs", link: "pune-to-konkan-darshan-cabs" },
        { place: "/images/keyword/12.jpg", text: "Pune Outstation Cabs", link: "pune-outstation-cabs" },
        { place: "/images/keyword/13.jpg", text: "Ashtavinayak Darshan Cab", link: "ashtavinayak-darshan-cab" },
        { place: "/images/keyword/14.jpg", text: "Pune to Goa Cabs", link: "pune-to-goa-cabs" },
        { place: "/images/keyword/15.jpg", text: "Cabs Services Near Me", link: "cabs-services-near-me" },
        { place: "/images/keyword/16.jpg", text: "Corporate Cab Service in Pune", link: "corporate-cab-service-in-pune" },
        { place: "/images/keyword/17.jpg", text: "Pune to Mumbai Airport Cabs", link: "pune-to-mumbai-airport-cabs" },
        { place: "/images/keyword/18.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
        { place: "/images/keyword/19.jpg", text: "Urbania On Rent in Pune", link: "urbania-on-rent-in-pune" },
        { place: "/images/keyword/20.jpg", text: "Innova Crysta On Rent in Pune", link: "innova-crysta-on-rent-in-pune" },
        { place: "/images/keyword/21.jpg", text: "Bus On Rent in Pimpri Chinchwad", link: "bus-on-rent-in-pimpri-chinchwad" },
        { place: "/images/keyword/22.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
        { place: "/images/keyword/23.jpg", text: "Ertiga On Rent in Pune", link: "ertiga-on-rent-in-pune" },
        { place: "/images/keyword/24.jpg", text: "Pune to Sambhaji Nagar Taxi", link: "pune-to-sambhaji-nagar-taxi" },
        { place: "/images/keyword/25.jpg", text: "Pune to Ganpatipule Taxi", link: "pune-to-ganpatipule-taxi" }
    ];







const airportPickupSchema = {
  "@context": "https://schema.org",
  "@type": "TaxiService",
  "name": "Platinum24 Cabs",
  "url": "https://www.platinum24cab.com",
  "description": "Reliable and affordable Airport Pickup and Drop service in Pune offering 24x7 airport taxi, shuttle, and cab booking with driver.",
  "areaServed": {
    "@type": "City",
    "name": "Pune"
  },
  "serviceType": [
    "Pune Airport Pickup",
    "Pune Airport Drop Service",
    "Airport Transfer Pune",
    "Pune Airport Taxi Service",
    "Airport Pickup and Drop Cab Pune",
    "Pune Airport Shuttle",
    "Airport Taxi Booking Pune",
    "Airport Cab Service Pune",
    "Pune Airport Taxi with Driver",
    "Affordable Airport Pickup Pune",
    "Pune Airport Transfer Rates",
    "Pune Airport Taxi Deals",
    "Pune Airport Pick-up Booking",
    "Pune Airport Taxi Service 24x7",
    "Pune Airport Cab Service Near Me"
  ],
  "telephone": "+91-XXXXXXXXXX",
  "hasOfferCatalog": {
    "@type": "OfferCatalog",
    "name": "Pune Airport Transfer Services",
    "itemListElement": [
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "Airport Pickup Pune"
        }
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "Airport Drop Pune"
        }
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "Airport Shuttle Pune"
        }
      }
    ]
  }
};






    return (
        <div>

<Helmet>
  <title>Airport Pickup and Drop in Pune | Platinum24 Cabs</title>
  <meta
    name="description"
    content="Reliable and affordable Airport Pickup and Drop service in Pune offering 24x7 airport taxi, shuttle, and cab booking with driver."
  />
  <meta
    name="keywords"
    content="Pune Airport Pickup, Pune Airport Drop Service, Airport Transfer Pune, Pune Airport Taxi Service, Airport Pickup and Drop Cab Pune, Pune Airport Shuttle, Airport Taxi Booking Pune, Airport Cab Service Pune, Pune Airport Taxi with Driver, Affordable Airport Pickup Pune, Pune Airport Transfer Rates, Pune Airport Taxi Deals, Pune Airport Pick-up Booking, Pune Airport Taxi Service 24x7, Pune Airport Cab Service Near Me"
  />
  <script type="application/ld+json">
    {JSON.stringify(airportPickupSchema)}
  </script>
</Helmet>


            <div
                className="breadcumb-wrapper"
                // style={{ backgroundImage: "url('/img/breadcumb/breadcumb-bg.jpg')" }}
            >
                <div className="container z-index-common">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                        <div className="breadcumb-menu-wrap">
                        </div>
                    </div>
                </div>
            </div>










            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/53.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">
                                <p className="sectionLead">{cardData.top}</p>

                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>
                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>
                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        <div className="service-icon">
                                            🚖
                                        </div>
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title">
                                    Why Choose <span>Platinum24 Cabs</span>
                                </h2>

                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Platinum24 Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+917507048333" className="pc-call">+91 7507048333</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/917507048333"
                                                target="_blank" rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp me-1"></i> WhatsApp
                                            </a>
                                            <a href="tel:+917507048333" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@platinum24cab.com" className="pc-email">
                                            booking@platinum24cab.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-house-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Platinum24 Cabs</strong><br />
                                            OFFICE NO.2, SECTOR NO.4, PLOT NO.295(S), SAI GANGA APARTMENT, ABOVE UMED ELECTRICAL, NEAR ACORD HOSPITAL
                                            FIRST FLOOR, SANT NAGAR, MOSHI, PUNE 412105
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Airportpickupanddropinpune;